import {observer} from 'mobx-react';
import {Button} from 'shared/components';
import {InteractiveAccordionTable} from 'main/components';
import DocumentFoldersState from '../state/DocumentFoldersState';
import DocumentFolder from 'main/stores/document_folders/DocumentFolder';
import {FormattedMessage} from 'react-intl';
import {t, withState} from 'shared/core';
import {endpoints, types} from 'main/tools';
import useModal from 'shared/hooks/useModal';
import SubNav from 'main/containers/company_settings/SubNav';
import EditDocumentFolderModal from './EditDocumentFolderModal';
import ReorderFoldersModal from './ReorderFoldersModal';

export const NameCell = observer(({model, level}) => {
  const folder = model;
  return (
    <div>
      {!!folder.parentFolderName && level === 0 && <div className='flex align-items-middle mb1'>
        <i className='jumbo mr1 material-symbols-solid h4'>{'arrow_forward'}</i>
        <span className='jumbo'>{folder.parentFolderName}</span>
      </div>}
      {folder.name}
    </div>
  );
});

const COLUMNS = [
  {
    header: 'company_settings.document_folders.Name',
    component: NameCell,
    width: 11
  }
];

const NESTED_ROWS = [
  {attribute: 'subfolders'}
];

const LOCALIZATION = {
  removeModal: {
    header: 'company_settings.document_folders.Delete Document Folder',
    subHeader: 'company_settings.document_folders.Are you sure you want to delete this folder?',
    body: 'company_settings.document_folders.DELETE_FOLDER_MESSAGE'
  },
  emptyState: 'company_settings.document_folders.No folders to display',
  interactive: {
    addModel: 'company_settings.document_folders.+ Add a Folder'
  }
};

const DocumentFoldersContainer = observer(({uiState}) => {
  const {canViewNestedFolders} = uiState;
  const reorderFoldersModalOpen = useModal(uiState, 'ReorderFoldersModal');

  return (
    <div>
      <SubNav title={t('company_settings.subnav.Document Folders')}/>
      <div className='Container mb4'>
        <InteractiveAccordionTable
            uiState={uiState}
            columns={COLUMNS}
            title={t('company_settings.document_folders.Document Folders')}
            proxy={{
              type: 'async',
              endpoint: endpoints.FOLDERS.withParent(null),
              modelType: types.FOLDER,
              model: DocumentFolder
            }}
            canExpand={folder => canViewNestedFolders && folder.hasSubfolders}
            onExpand={folder => uiState.fetchSubfolders(folder)}
            nestedRows={NESTED_ROWS}
            onEditClicked={folder => uiState.editDocumentFolder(folder)}
            onRemove={folder => uiState.deleteDocumentFolder(folder)}
            customLinks={folder => uiState.customLinksFor(folder)}
            onMount={agent => uiState.setInteractiveAgent(agent)}
            onRefresh={args => uiState.updateInteractiveContextState(args)}
            localization={LOCALIZATION}
            paginatable={false}
            onAdd={() => uiState.addDocumentFolder()}
            tableActionButtons={
              <Button className='mr2' size='md' trait='default' onClick={() => uiState.openReorderFoldersModal()}>
                <FormattedMessage id='company_settings.document_folders.Reorder Folders'/>
              </Button>
            }
          />
        <ReorderFoldersModal modalOpen={reorderFoldersModalOpen} uiState={uiState}/>
        <EditDocumentFolderModal uiState={uiState}/>
      </div>
    </div>
  );
});

export default withState(DocumentFoldersContainer, DocumentFoldersState);
